module.exports = __webpack_public_path__ + "datahub/img/clipboard.a754c187.svg";